import React from "react";
import ParallaxSection from "../components/parallax";
import Carousel from "../components/carousel";

function PnfHelperPage() {
  const slides = [
    <img
      src="/app_images/pnf_helper/01_overview.png"
      alt="Overview"
      style={{ maxWidth: "100%", maxHeight: "100%" }}
    />,
    <img
      src="/app_images/pnf_helper/02_ciphers.png"
      alt="Ciphers"
      style={{ maxWidth: "100%", maxHeight: "100%" }}
    />,
    <img
      src="/app_images/pnf_helper/03_stats.png"
      alt="Statistics"
      style={{ maxWidth: "100%", maxHeight: "100%" }}
    />,

    <img
      src="/app_images/pnf_helper/04_binaryMorse.png"
      alt="Hidden Insights"
      style={{ maxWidth: "100%", maxHeight: "100%" }}
    />,

    <img
      src="/app_images/pnf_helper/05_decrypting.gif"
      alt=""
      style={{ maxWidth: "100%", maxHeight: "100%" }}
    />,
  ];
  return (
    <>
      <ParallaxSection className="product-hero">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "2rem",
          }}
        >
          <img
            src="/website_images/logo512.png"
            alt="P&F Helper Logo"
            style={{ width: "80px", height: "80px", objectFit: "contain" }}
          />
          <div>
            <h1><a href="https://pandfhelper.woolworthsoftware.com" style={{ color: 'inherit', textDecoration: 'none' }}>P&F Helper</a></h1>
            <p>Welcome to Word Search Help</p>
          </div>
          <img
            src="/website_images/logo512.png"
            alt="P&F Helper Logo"
            style={{ width: "80px", height: "80px", objectFit: "contain" }}
          />
        </div>
      </ParallaxSection>
      <div className="product-content">
        <Carousel slides={slides} interval={10000} />
        <div className="product-description" style={{ margin: "2rem 0" }}>
          <p>
            P&F Helper is a powerful companion tool designed specifically to
            assist with solving the challenging word search puzzle found in Part
            Two of <em>There's Treasure Inside</em> by Jon Collins-Black,
            located in the "Past & Future Box" chapter. Whether you're a
            seasoned puzzler or a curious explorer, this app gives you full
            control over the puzzle grid to uncover hidden patterns, decipher
            clues, and track your progress.
          </p>
        </div>
        <div className="product-features">
          <div className="product-feature">
            <h3>🔧 Grid Operations</h3>
            <p>
              Transpose the grid to view from a new perspective, reverse rows or
              columns to uncover mirrored clues, shift rows and columns to
              experiment with letter arrangements, hide characters to reduce
              visual clutter or isolate patterns, set current view as default
              for easy reversion after experimentation, and clear all applied
              operations or perform a hard reset to start fresh.
            </p>
          </div>
          <div className="product-feature">
            <h3>🎨 Formatting Tools</h3>
            <p>
              A variety of formatting tools allow you to highlight or erase all
              instances of a letter, highlight or remove highlights from all
              instances of a specific color, remove erasure from all instances
              of a letter or color, and clear all highlighting in one click.
            </p>
          </div>
          <div className="product-feature">
            <h3>🔐 Cipher Tools</h3>
            <p>
              Apply classic ciphers to the grid, including Caesar, Vigenere,
              Atbash, Substitution, and Rail Fence. Clear all ciphers at any
              time to return to your original view.
            </p>
          </div>
          <div className="product-feature">
            <h3>📊 Letter Frequency Analysis</h3>
            <p>
              A live statistics panel analyzes the frequency of highlighted
              letters in real time, comparing your selections against standard
              English letter frequencies and random distribution models to
              detect non-random patterns. Each string is displayed with
              percentage-based deviation from expected frequencies and
              color-coded indicators.
            </p>
          </div>
          <div className="product-feature">
            <h3>🔍 Hidden Insights</h3>
            <p>
              Embedded secret logic transforms highlighted I's and O's into
              binary and Morse code. These alternate representations may help
              reveal hidden clues or encoded messages buried within the puzzle
              grid—perfect for treasure hunters looking beyond the surface.
            </p>
          </div>
          <div className="product-feature">
            <h3>📤 Export & Save</h3>
            <p>
              Export the current puzzle state to Excel for further analysis or
              backup. Keep a record of your progress and share your findings
              with fellow treasure hunters.
            </p>
          </div>
        </div>
        <div className="product-description" style={{ margin: "2rem 0" }}>
          <p>
            Whether you're lining up five clues, navigating the bends and turns,
            or just remaining steady, P&F Helper gives you a flexible and
            intuitive interface to manipulate, analyze, and solve one of the
            book's most intriguing puzzles. Unlock deeper patterns. Decode the
            unseen. Let your hunt begin.
          </p>
        </div>
      </div>
    </>
  );
}

export default PnfHelperPage;
